import React from "react";
import PropTypes from "prop-types";
import CustomImage from "../../../atoms/customImage";

/**
 * Component to display a customizable error message with an icon.
 *
 * @component
 * @example

 *
 * @param {Object} props - Component props
 * @param {string} props.message - The main error message to display.
 * @param {string} [props.subMessage] - Optional sub-message to display below the main message.
 * @param {string} [props.icon="/icons/warning.svg"] - The path to the icon to display.
 * @param {string} [props.containerClasses=""] - Additional CSS classes for the container.
 * @param {number} [props.iconSize=16] - The size of the icon.
 * @returns {JSX.Element} The rendered error message component.
 */
const ErrorMessage = ({
  message,
  subMessage = "",
  icon = "/icons/warning-circle.svg",
  containerClasses = "",
  iconSize = 16,
}) => {
  return (
    <span
      data-testid="input_related_message"
      className={`mt-10 flex items-center rounded-4 bg-red-100 bg-opacity-5 p-[5px] text-sm font-normal tracking-wide ${containerClasses}`}
    >
      <div>
        <CustomImage src={icon} width={iconSize} height={iconSize} alt="error-icon" sizes="10vw" isPriority={false} />
      </div>
      <p className="ml-4 font-inter text-[12px] font-medium leading-[1.34] text-grey-500">
        <span className="block sm:inline">{message}</span>{" "}
        {subMessage && <span className="block sm:inline">{subMessage}</span>}
      </p>
    </span>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  subMessage: PropTypes.string,
  icon: PropTypes.string,
  containerClasses: PropTypes.string,
  iconSize: PropTypes.number,
};

export default ErrorMessage;
